import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { footer: f, branding } = useContent();

  return (
    <footer className="foot dk" data-testid="footer">
      <div className="wrap">
        <div className="row">
          {f?.email && (
            <span>
              <a href={`mailto:${f.email}`} data-testid="footer-email-link">{f.email}</a>
            </span>
          )}
          {f?.instagram && (
            <span>
              <a href={f.instagram_url || "#"} target="_blank" rel="noreferrer" data-testid="footer-instagram-link">{f.instagram}</a>
            </span>
          )}
          {f?.web && (
            <span>
              <a href={f.web_url || "#"} target="_blank" rel="noreferrer" data-testid="footer-web-link">{f.web}</a>
            </span>
          )}
          {f?.meta && <span>{f.meta}</span>}
        </div>

        <span className="big" aria-hidden="true">
          {branding?.logo_text || "TAANDEM"}<i>.</i>
        </span>

        <div className="row" style={{ marginTop: 28, opacity: 0.6 }}>
          <span>© {new Date().getFullYear()} {f?.bottom_left}</span>
          <span>{f?.bottom_right}</span>
        </div>
      </div>
    </footer>
  );
};
